import { useContext, useEffect, useRef, useState } from 'react';
import classes from './styles.module.scss';
import { IonButton, IonIcon } from '@ionic/react';
import Nav from '../../../components/Layout/user/nav';
import { useHistory } from 'react-router-dom';
import ContactUsForm from '../../../components/contactusForm/contact';
import FaqsItem from '../../../components/Faqs';
import { FaqsType } from '../../../types/faqs';
import { faqs } from '../../../data/faqs';
import { Link } from 'react-router-dom';
import { getCurrentUser } from '../../../utils/getClientInfo';
import BecomeASellerModal from '../../../components/becomeSellerModal';
import AddToHomeScreen from '../../../components/AddToHomeScreen';
import { LandingPageData } from '.';
import logo from '../../../Assets/logo/logo_white_background_96.svg';
import { AboutRoutes } from '../../../utils/user/routes';
import { DeviceContext } from '../../../deviceType';
import { gsap } from 'gsap';
import SplitType from 'split-type';
import VideoPlayer from '../../../components/videoPlayer';

const Desktop = ({ data, video }: { data: LandingPageData; video: any }) => {
  useContext(DeviceContext); 
  const history = useHistory();
  const userData = getCurrentUser();
  const isLoggedIn = !!Object.keys(userData).length;
  const isVendor = isLoggedIn && userData?.role === 'seller';
  const isBuyer = isLoggedIn && userData?.role === 'user';
  const hasStore = isVendor && userData?.stores?.length;
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const animated_text_ref = useRef<any>(null);

  const filterQuestions = faqs.filter((item: FaqsType, index: number) => {
    return index <= 3;
  });
  useEffect(() => {
    if (!animated_text_ref.current) return;

    const text = new SplitType(animated_text_ref.current, { types: 'words' });

    text.words?.forEach((word, index) => {
      let highlight = document.createElement('span');
      word.classList.add('mr-4');
      if (index === 1) {
        word.classList.add('relative', 'text-italic', 'mr-2');
        highlight.className = `absolute left-0 bottom-0 w-full h-[15px] highlight_secondary scale-x-0 origin-right`;
        word.appendChild(highlight);
        return;
      }
      word.classList.add('relative');
      highlight.className = `absolute left-0 bottom-0 w-full h-[15px] highlight_primary scale-x-0 origin-left`;
      word.appendChild(highlight);
    });

    const words = animated_text_ref.current.querySelectorAll('.word');
    const highlights = animated_text_ref.current.querySelectorAll('.word span');

    gsap
      .timeline({ delay: 0.5, repeat: -1, repeatDelay: 2 })
      .from(words, {
        opacity: 0,
        duration: 0.4,
        stagger: 0.6,
        ease: 'power2.out',
      })
      .to(words, {
        opacity: 1,
        duration: 0.4,
        stagger: 0.6,
        ease: 'power2.out',
      })
      .to(
        highlights,
        {
          scaleX: 1,
          duration: 0.7,
          stagger: 0.6,
          ease: 'power2.out',
        },
        '-=0.6'
      );
  }, []);

  const onCreateStoreBtnClick = () => {
    if (!isLoggedIn) {
      // history.push('/registervendor');
      history.push('/signup');
    } else if (isBuyer) {
      setIsModalOpen(true);
    } else if (isVendor && !hasStore) {
      history.push('/dashboard/create-store');
    } else if (isVendor && hasStore) {
      history.push('/dashboard/store');
    }
  };

  const getCreateStoreBtnText = () => {
    if ((isLoggedIn && isBuyer) || (isLoggedIn && isVendor && !hasStore)) {
      return 'Create Business Profile';
    } else if (isLoggedIn && isVendor && hasStore) {
      return 'Manage Business';
    }
    return 'Start Free';
  };

  return (
    <div className="w-full h-[100dvh] overflow-y-scroll">
      {/* Become vendor modal */}
      <BecomeASellerModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
      <div
        className={
          classes.nav + ' md:px-4 w-full bg-white h-[10%] fixed z-10 md:py-2'
        }
      >
        <Nav backgroundColor={'white'} />
      </div>

      {/* content */}
      {/* IMPORTANT: Don't remove the main-content id. It's to match the menu content */}
      <div
        id="main-content"
        className={'mt-[10dvh] relative w-full h-auto overflow-x-hidden'}
      >
        {/* showcase */}
        <div className="w-full h-[90dvh]  md:h-[90dvh] grid grid-cols-2 grid-rows-[max-content] md:grid-rows-none items-start">
          <div className="h-[40dvh] md:h-full w-auto col-span-2 md:col-span-1">
            <div
              className={
                'h-full px-6 md:px-0 md:pl-[12.3%] w-full flex flex-col  justify-center'
              }
            >
              <div
                ref={animated_text_ref}
                className="text-primary text-3xl md:text-[2.5rem] mb-1 font-roboto font-normal py-2 text-center md:text-start"
              >
                {data.showcase?.primary}
              </div>
              <div className="text-primary] text-lg font-roboto font-base font-light  text-center md:text-start md:text-xl">
                {data.showcase!.secondary}
              </div>
              <div className="mt-6 md:w-[40%] w-[80%] mx-auto md:mx-0 h-[3rem]">
                <IonButton
                  className={'!size-full m-0 p-0 font-medium'}
                  fill="solid"
                  color="primary"
                  style={{ 'font-weight': 'medium' }}
                  onClick={onCreateStoreBtnClick}
                >
                  {getCreateStoreBtnText()}
                </IonButton>
                {/* {!isVendor && (
                  <IonButton
                    className={'!size-full m-0 p-0 font-medium mt-4'}
                    fill="outline"
                    color="secondary"
                    style={{ 'font-weight': 'medium' }}
                    onClick={() => history.push('/stores')}
                  >
                    Browse
                  </IonButton>
                )} */}
                {/* {
                      !isLoggedIn &&
                      <IonButton
                        className={classes.btn}
                        fill="clear"
                        color="secondary"
                        routerLink="/signup"
                      >
                        Join as a Shopper
                      </IonButton>
                    } */}
              </div>
            </div>
          </div>
          <div className="h-[40dvh] md:h-full w-auto flex items-center justify-center col-span-2 md:col-span-1">
            <div className="relative w-full md:h-[80%] h-full my-[auto] flex flex-col items-center justify-center md:pr-[10%]">
              <div className={'w-full h-auto aspect-[15/9] px-4'}>
                <img
                  src={data.showcase?.showcase_img!}
                  alt="showcase dashboard"
                  className="object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            {/* <div className="w-full md:w-[70%] md:mx-auto pb-4 md:pb-0 h-[40%] md:h-[30%] grid grid-cols-2  grid-flow-row-dense gap-2">
              {data!.showcase?.showcase_stat.map((item, index: number) => (
                <div
                  className={
                    'h-auto w-[60%] md:w-auto mx-auto md:mx-0 flex flex-col items-center md:col-span-1 col-span-2'
                  }
                  key={index}
                >
                  <div className="w-auto h-auto pb-1 text-[var(--ion-color-secondary)]  font-semibold text-xl">
                    {item.label}
                  </div>
                  <div className="w-[15%] h-auto aspect-square flex items-center justify-center pb-1">
                    <IonIcon
                      icon={item.icon as string}
                      color="light"
                      className="size-full"
                    ></IonIcon>
                  </div>
                  <div className="w-auto h-auto pb-1 text-[var(--ion-color-secondary)]  font-semibold text-xl">
                    {item.statistic}
                  </div>
                  <div className="text-center w-auto h-[20%] pb-1 text-white  text-sm px-2">
                    {item.description}
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>

        {/* why us */}
        <div className={'w-full h-auto px-[6%] py-4 pt-0'}>
          <div
            className={
              'w-full md:w-auto h-auto py-2 text-[var(--ion-color-secondary)] text-2xl font-bold  text-center '
            }
          >
            {data.whyus!.label}
          </div>
          <div className="w-auto h-auto py-2 text-[var(--ion-color-primary)] text-base font-normal text-center ">
            {data.whyus!.sub}
          </div>
<div className="w-full h-auto py-6 pb-12 grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 justify-center">
  {data.whyus!.list.map((e, index) => (
    <div
      key={index}
      className="flex flex-col items-center px-4"
    >
      <IonIcon
        src={e.icon}
        className="aspect-square w-12 h-12 my-2"
      />
      <div className="text-center text-[var(--ion-color-primary)] font-semibold text-lg">
        {e.name}
      </div>
      <div className="text-center text-[var(--ion-color-primary)] font-base text-base">
        {e.body}
      </div>
    </div>
  ))}
</div>

        </div>

        {/* become a vendor */}
        {/* <div className="w-full h-fit px-8 md:px-[6%] py-4 grid grid-cols-2 grid-flow-row-dense gap-2">
          <div className="w-full h-auto md:h-full overflow-hidden  col-span-2">
            <div
              className={
                'w-full md:w-auto h-auto py-2 text-[var(--ion-color-secondary)] text-2xl font-bold  text-center'
              }
            >
              {data.becomevendor!.label}
            </div>
            <div className=" w-full md:w-auto h-auto py-2 text-[var(--ion-color-primary)] text-base font-base text-center ">
              {data.becomevendor!.sub}
            </div>
          </div>
          <div className="w-full h-auto  p-0 md:p-4 md:px-[8%] col-span-2 ">
            <div className="w-full h-atuo aspect-video overflow-hidden rounded-3xl md:rounded-[2rem] ">
              <VideoPlayer
                url={data.becomevendor?.video!}
                autoplay
                fileType="video/mp4"
              />
            </div>
          </div>
        </div> */}

        {/* FAQS */}
        <div className={'w-full h-auto px-[6%] py-4 '}>
          <div
            className={
              'w-full md:w-auto h-auto py-2 text-[var(--ion-color-secondary)] text-2xl font-bold  text-center'
            }
          >
            {data.faqs!.label}
          </div>
          <div className={'w-full h-auto py-4'}>
            {filterQuestions.map((item: FaqsType, index: number) => {
              return (
                <FaqsItem
                  key={index}
                  title={item.title}
                  content={item.content}
                />
              );
            })}
          </div>
          <div className="w-full h-auto py-2 flex item-center justify-center">
            <Link
              to={'/faqs'}
              className={
                'text-[var(--ion-color-secondary)] font-semibold text-sm mx-2'
              }
            >
              View More
            </Link>
          </div>
        </div>

        {/* contact us */}
        <div className="w-full h-auto p-4" id="contactus">
          <div className="w-full h-auto bg-[var(--ion-color-primary-tint)] rounded-[2rem] md:rounded-[3rem] py-6 px-4 md:py-10 md:px-[4.6%] grid grid-cols-2 grid-flow-row-dense gap-2 pb-10">
            <div className=" col-span-2 w-auto h-auto py-2 text-white text-2xl font-bold  text-center md:text-start">
              {data.contact!.label}
            </div>
            <div
              className={
                'col-span-2 order-2 md:order-1 md:col-span-1 md:px-4 flex justify-center md:justify-start border-r-0 md:border-r-2 border-white'
              }
            >
              <ContactUsForm />
            </div>
            <div className=" col-span-2 md:col-span-1 px-4 md:px-10 order-1 md:order-2">
              <div className="text-white text-normal font-medium  py-2 text-center md:text-start">
                {data.contact!.sub}
              </div>
              <div className=" py-2 flex flex-col items-start">
                {data.contact!.contacts.map((e) => {
                  return (
                    <div
                      key={e}
                      className="w-full text-white text-normal font-medium  pb-2 text-center md:text-start"
                    >
                      {e}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddToHomeScreen />

      {/* footer */}
      <div className="w-full h-auto mt-auto px-6 pb-[2.5rem]">
        <div className="w-full h-auto flex items-center justify-between mb-4 mt-8">
          <div className="h-auto w-[50%] flex items-center ">
            <IonIcon
              src={logo}
              className="aspect-square h-auto w-[2rem] md:w-[6%] mx-2"
            ></IonIcon>
            <span className="text-[var(--ion-color-primary)]  font-bold text-lg">
              Bazaar
            </span>
            <span className="text-[var(--ion-color-secondary)] italic  font-bold text-lg">
              Cheap
            </span>
          </div>
          <div className="flex items-center  w-auto h-full">
            {AboutRoutes.map((item, index) => {
              return (
                <Link
                  to={item.route}
                  className={
                    'text-[var(--ion-color-primary)]  font-semibold text-sm mx-2'
                  }
                  key={index}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
        </div>
        <div className="w-full h-auto border-t-2 border-gray-200 flex items-center justify-between">
          <div className="text-gray-400  font-medium text-sm py-4 px-2">
            Copyright &copy; Bazaar Cheap {new Date().getFullYear()}
          </div>
          <div className="w-auto h-full">
            <IonButton
              onClick={() => {}}
              fill="clear"
              className="text-gray-500  font-medium text-sm"
            >
              Terms of Use
            </IonButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Desktop;